import { Whatsapp } from '@styled-icons/boxicons-logos/Whatsapp'
import button from 'assets/svg/whats/whatsbutton.svg'
import logo from 'assets/png/icons/logo.png'

export default {
  image: {
    src: button,
    alt: `Tirar dúvidas sobre os produtos do site`
  },
  logo: {
    src: logo,
    alt: `Tirar dúvidas sobre os produtos do site`
  },
  dialog: `Está com dúvidas? Fale comigo!`,
  dialogWindow: [
    `Sucesso do Aluno`,
    `Tire suas dúvidas aqui!`,
    `Ei, Vestibulando!`,
    `Fale comigo e aproveite os planos para se preparar para o
        ENEM! Ainda dá tempo de conseguir aquele notão!😍`
  ],
  buttonProps: {
    label: `Clicar e falar :)`,
    icon: { src: Whatsapp, alt: 'ícone whatsapp' }
  },
  chatInfo: {
    footer: {
      defaultLabel: 'Me ajuda, Proenem!',
      iconName: 'send-chat-fill',
      iconColor: 'primary'
    }
  }
}
